import { defaultPrefixCls } from '../../config-provider';
export const TARGET_CLS = `${defaultPrefixCls}-wave-target`;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/wave/interface.js
// module id = 283
// module chunks = 0